import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, Select } from "antd";

import { getOptions } from "../../../helpers/options";
import {
  getDefaultEstablishment,
  getEstablishment,
} from "../../http-request/establishment";
import styles from "./styles/CreateAccountPage.module.css";

import { genderValues } from "./initialValues";
import { OPTIONS } from "../../../constants";

/**
 * Initialize Form Items that is use for user Creation
 *
 * @param forms - Inherits the form api's
 * @returns The field values
 *
 */

export const FormFields = (forms) => {
  const [establishments, setEstablishments] = useState([]);
  const [defaultEstablishment, setdefaultEstablishment] = useState([]);
  const [allEstablishment, setallEstablishment] = useState([]);

  useEffect(() => {
    loadEstablishment();
  }, []);

  const loadEstablishment = async () => {
    await getEstablishment().then(({ establishments }) => {
      let _data = getOptions({
        data: establishments,
        value: "_id",
        label: "name",
      });
      setallEstablishment(_data);
      setEstablishments(_data);
    });

    await getDefaultEstablishment().then(({ establishments }) => {
      let _data = getOptions({
        data: establishments,
        value: "_id",
        label: "name",
      });
      setdefaultEstablishment(_data);
    });
  };

  const onUserTypeChange = (values) => {
    forms.setFieldsValue({
      establishment: "",
    });
    if (values === "Administrator") {
      setEstablishments(defaultEstablishment);
    } else {
      setEstablishments(allEstablishment);
    }
  };

  const phoneNumberFormat = /^09\d{9}$/;
  const phoneValidation = {
    pattern: phoneNumberFormat,
    message: "Please enter a valid Phone Number",
    validator: (rule, value) => {
      if (!phoneNumberFormat.test(value)) {
        return Promise.reject("Please enter a valid Phone Number");
      }
      return Promise.resolve();
    },
  };
  return (
    <>
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="usertype"
            label="User Type"
            rules={[
              {
                required: true,
                message: "Please select User Type",
              },
            ]}
          >
            <Select
              onChange={onUserTypeChange}
              className={styles.textLeft}
              options={OPTIONS.userTypeValues}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="userlevel"
            label="User Level"
            rules={[
              {
                required: true,
                message: "Please select a User Level",
              },
            ]}
          >
            <Select
              className={styles.textLeft}
              options={OPTIONS.userLevelValues}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="firstname"
            label="First Name"
            rules={[
              {
                required: true,
                message: "Please input your First Name",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="lastname"
            label="Last Name"
            rules={[
              {
                required: true,
                message: "Please input your Last Name",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="gender"
            label="Sex"
            rules={[
              {
                required: true,
                message: "Please input your Gender",
              },
            ]}
          >
            <Select className={styles.textLeft} options={genderValues} />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="phonenumber"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: "Please input your Phone Number",
              },
              phoneValidation,
            ]}
          >
            <Input placeholder="0912 345 6789" pattern="[0-9]*" />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="email"
            label="Email"
            rules={[
              {
                type: "email",
                message: "Please input a correct Email",
              },
              {
                required: true,
                message: "Please input your Email",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="password"
            label="Password"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please input your Password",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="confirmPassword"
            label="Confirm Password"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please confirm you password by typing it again!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="establishment"
            label="TRE Affiliation"
            rules={[
              {
                required: true,
                message: "Please select Establishment",
              },
            ]}
          >
            <Select className={styles.textLeft} options={establishments} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
